import {httpsCallable} from 'firebase/functions';
import {functions} from '../../lib/firebase';
const call=payload=>httpsCallable(functions,'lectureExample',{timeout:180000})(payload).then(result=>result.data);
export const newExampleId=()=>window.crypto?.randomUUID?.() || `example-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export const startExampleSession=lectureId=>call({action:'start',lectureId});
export const endExampleSession=(lectureId,sessionId)=>call({action:'end',lectureId,sessionId});
export const hideLectureExample=(lectureId,sessionId)=>call({action:'hide',lectureId,sessionId});
export const generateLectureExample=(lectureId,sessionId,requestId,description)=>call({action:'generate',lectureId,sessionId,requestId,description});
export const getLectureExampleImage=(lectureId,sessionId,requestId)=>call({action:'image',lectureId,sessionId,requestId});
export const getLectureExampleStatus=lectureId=>call({action:'status',lectureId});
// This endpoint checks the current server-side role and paper permissions on
// every read. Never subscribe to student-readable lecture data for AI images.
export function watchLectureExample(lectureId,onData,onError,{intervalMs=4000}={}) {
    let stopped=false,timer;
    async function poll(){
        let terminal=false;
        try{const data=await getLectureExampleStatus(lectureId);if(!stopped)onData(data);}
        catch(error){terminal=['functions/permission-denied','functions/unauthenticated','permission-denied','unauthenticated'].includes(error.code);if(!stopped)onError(error);}
        if(!stopped && !terminal)timer=setTimeout(poll,intervalMs);
    }
    void poll();
    return()=>{stopped=true;clearTimeout(timer);};
}
export function visibleLectureExample(data,now=Date.now()) {
    const state=data?.aiExample;
    if(state?.enabled!==true || typeof state.sessionId!=='string' || !state.sessionId || typeof state.requestId!=='string' || !state.requestId)return null;
    const time=state.updatedAtMs;
    if(!Number.isFinite(time) || time>now+60000 || time<now-12*60*60*1000)return null;
    if(state.status==='generating' && time<now-200000)return null;
    if(state.status==='generating')return {id:state.requestId,sessionId:state.sessionId,status:'generating',createdAtMs:time};
    const cue=state.activeExample;
    if(state.status!=='ready' || !cue || typeof cue.id!=='string' || cue.id!==state.requestId || !cue.id || typeof cue.imagePath!=='string' || !Number.isFinite(cue.createdAtMs) || cue.createdAtMs<now-12*60*60*1000 || cue.createdAtMs>now+60000)return null;
    if(!/^lecture-ai-images\/[A-Za-z0-9_-]+\/[A-Za-z0-9_-]+\/[a-f0-9]{64}\.(png|jpg|webp)$/.test(cue.imagePath))return null;
    return {...cue,sessionId:state.sessionId,status:'ready',title:String(cue.title || 'Example illustration').slice(0,160)};
}
